import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Constant } from 'src/app/Common/constant';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ConfirmationDialogComponent } from 'src/app/Base/confirmation-dialog/confirmation-dialog.component';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { RiderDetails } from 'src/app/Model/Rider/rider-details';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { logOutApp } from 'src/myfunc';
import { ImagePreviewDialogComponent } from '../image-preview-dialog/image-preview-dialog.component';
const { disableFileChhoserfunction, disableFileChhoserfunctionCamera, downloadFile } = require('src/myfunc.js')

@Component({
  selector: 'app-rider-details',
  templateUrl: './rider-details.component.html',
  styleUrls: ['./rider-details.component.css']
})
export class RiderDetailsComponent implements OnInit {
  educationDetails: string[] = ['10th', '12th', 'Graduation', 'Post Graduation'];
  isAgreedTerms: boolean = false;

  uploadedFileAadhaar: File;
  uploadedFileNameAadhaar: string = "";
  uploadedSignURLAadhaar: string = "";
  uploadTypeAadhaar: any;
  uploadSizeAadhaar: any;
  uploadImgDivAadhaar: boolean = false;

  uploadedFileAadhaarBack: File;
  uploadedFileNameAadhaarBack: string = "";
  uploadedSignURLAadhaarBack: string = "";
  uploadTypeAadhaarBack: any;
  uploadSizeAadhaarBack: any;
  uploadImgDivAadhaarBack: boolean = false;

  uploadedFileSelfie: File;
  uploadedFileNameSelfie: string = "";
  uploadedSignURLSelfie: string = "";
  uploadTypeSelfie: any;
  uploadSizeSelfie: any;
  uploadImgDivSelfie: boolean = false;

  uploadedFileDl: File;
  uploadedFileNameDl: string = "";
  uploadedSignURLDl: string = "";
  uploadTypeDl: any;
  uploadSizeDl: any;
  uploadImgDivDl: boolean = false;

  uplodedFileForAddhar: any;
  uplodedFileForRider: any;
  uploadedFileForAadhaarBack: any;
  uploadedFileForDl: any;

  isAnimate: boolean = false;
  today: Date = new Date();
  createSetupForm: UntypedFormGroup;
  companyCode: number
  companyName: number
  parentLocationName: string;
  riderEmail: string;
  riderDetails: RiderDetails = new RiderDetails();

  button: string = "SUBMIT";

  isRiderAgree: boolean = false;
  freeze: boolean = false;

  riderSelfie: any;
  aadhaarImage: any;
  aadhaarBackImage: any;
  displayBackBtn: boolean = false;

  private createRiderSubscription: Subscription;
  private getRiderByEmailSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  private imageSubscription: Subscription;


  constructor(
    public dialog: MatDialog,
    private constant: Constant,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastrService,
    private localStorage: LocalStorageService,
    private apiUrl: APIFactoryEndPoints,
    private domSanitizer: DomSanitizer,
    private route: Router,
    public createRiderService: RiderService,
  ) {
    const max = new Date();
    this.today = new Date(
      max.getFullYear() - 18,
      max.getMonth(),
      max.getDate()
    );
  }

  ngOnInit(): void {
    console.log("Received EMail1=" + this.localStorage.get("google_email"))
    if (this.localStorage.get("OS") == "Android")
      this.riderEmail = this.localStorage.get("google_email").replaceAll("\"", "")
    else
      this.riderEmail = JSON.parse(this.localStorage.get("google_email"));
    console.log("Received EMail2=" + this.riderEmail)
    this.onCreateSetup();
    this.getRiderByEmail();
  }

  ngOnDestroy() {
    if (this.createRiderSubscription !== undefined)
      this.createRiderSubscription.unsubscribe();

    if (this.getRiderByEmailSubscription !== undefined)
      this.getRiderByEmailSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  openPrivacyPolicyDialog() {
    const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
      width: "500px",
      height: "500px",
      data: "generalTerms",
      autoFocus: false,
      panelClass: ["animate__animated", "animate__slideInUp"],
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  onAgreedTermsChange(checked: boolean) {
    console.log(checked);
  }

  handleFileInput(files: FileList) {
    this.uploadAadharDiv = true;
    this.savedAddharFile = null;

    if (files[0].size > this.constant.uploadFileSize)
      alert(this.constant.fileBigSize);
    else {
      this.uploadedFileAadhaar = files.item(0);
      this.uploadedFileNameAadhaar = this.uploadedFileAadhaar.name;
      this.uploadTypeAadhaar = this.uploadedFileAadhaar.type;
      this.uploadSizeAadhaar = ((files.item(0).size / (1024 * 1024)) > 1) ? (files.item(0).size / (1024 * 1024)) + ' mB' : (files.item(0).size / 1024) + ' kB';
      this.uploadImgDivAadhaar = true;

      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedSignURLAadhaar = event.target.result;
      }
      reader.readAsDataURL(files.item(0));
    }
    this.createSetupForm.patchValue({
      aadhaarImagePath: this.uploadedFileNameAadhaar
    })
  }

  fileChooserAndroid(sourceType: string) {
    console.log(sourceType)
    disableFileChhoserfunction(sourceType)
  }

  removeImgAadhar() {
    this.savedAddharFile = null;
    this.uploadAadharDiv = true;
    this.uploadImgDivAadhaar = false;
    this.uploadedFileNameAadhaar = null;
    this.uploadedSignURLAadhaar = null;
    this.uploadedFileAadhaar = null;
    this.createSetupForm.get('aadhaarImagePath').reset();
    this.createSetupForm.get('aadhaarImage').reset();
  }

  handleFileInputCamera(files: FileList) {
    this.uploadRiderSelfieDiv = true;
    this.savedRiderSelfieForEdit = null;

    if (files[0].size > this.constant.uploadFileSize)
      alert(this.constant.fileBigSize);
    else {
      this.uploadedFileSelfie = files.item(0);
      this.uploadedFileNameSelfie = this.uploadedFileSelfie.name;
      this.uploadTypeSelfie = this.uploadedFileSelfie.type;
      this.uploadSizeSelfie = ((files.item(0).size / (1024 * 1024)) > 1) ? (files.item(0).size / (1024 * 1024)) + ' mB' : (files.item(0).size / 1024) + ' kB';
      this.uploadImgDivSelfie = true;

      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedSignURLSelfie = event.target.result;
      }
      reader.readAsDataURL(files.item(0));
    }
    this.createSetupForm.patchValue({
      riderSelfiePath: this.uploadedFileNameSelfie
    })
  }

  fileChooserAndroidCamera(sourceType: string) {
    console.log(sourceType)
    disableFileChhoserfunctionCamera(sourceType)
  }

  removeImgSelfie() {
    this.savedRiderSelfieForEdit = null;
    this.uploadRiderSelfieDiv = true;
    this.uploadImgDivSelfie = false;
    this.uploadedFileNameSelfie = null;
    this.uploadedSignURLSelfie = null;
    this.uploadedFileSelfie = null;
    this.createSetupForm.get('riderSelfiePath').reset();
    this.createSetupForm.get('riderSelfie').reset();
  }

  handleFileInputAadhaarBack(files: FileList) {
    this.uploadAadharBackDiv = true;
    this.savedAddharBackFile = null;

    if (files[0].size > this.constant.uploadFileSize)
      alert(this.constant.fileBigSize);
    else {
      this.uploadedFileAadhaarBack = files.item(0);
      this.uploadedFileNameAadhaarBack = this.uploadedFileAadhaarBack.name;
      this.uploadTypeAadhaarBack = this.uploadedFileAadhaarBack.type;
      this.uploadSizeAadhaarBack = ((files.item(0).size / (1024 * 1024)) > 1) ? (files.item(0).size / (1024 * 1024)) + ' mB' : (files.item(0).size / 1024) + ' kB';
      this.uploadImgDivAadhaarBack = true;

      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedSignURLAadhaarBack = event.target.result;
      }
      reader.readAsDataURL(files.item(0));
    }
    this.createSetupForm.patchValue({
      aadhaarBackImagePath: this.uploadedFileNameAadhaarBack
    })
  }

  fileChooserAndroidAadhaarBack(sourceType: string) {
    console.log(sourceType)
    disableFileChhoserfunction(sourceType)
  }

  removeImgAadhaarBack() {
    this.savedAddharBackFile = null;
    this.uploadAadharBackDiv = true;
    this.uploadImgDivAadhaarBack = false;
    this.uploadedFileNameAadhaarBack = null;
    this.uploadedSignURLAadhaarBack = null;
    this.uploadedFileAadhaarBack = null;
    this.createSetupForm.get('aadhaarBackImagePath').reset();
    this.createSetupForm.get('aadhaarBackImage').reset();
  }

  handleFileInputDl(files: FileList) {
    this.uploadDlDiv = true;
    this.savedDlFile = null;

    if (files[0].size > this.constant.uploadFileSize)
      alert(this.constant.fileBigSize);
    else {
      this.uploadedFileDl = files.item(0);
      this.uploadedFileNameDl = this.uploadedFileDl.name;
      this.uploadTypeDl = this.uploadedFileDl.type;
      this.uploadSizeDl = ((files.item(0).size / (1024 * 1024)) > 1) ? (files.item(0).size / (1024 * 1024)) + ' mB' : (files.item(0).size / 1024) + ' kB';
      this.uploadImgDivDl = true;

      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedSignURLDl = event.target.result;
      }
      reader.readAsDataURL(files.item(0));
    }
    this.createSetupForm.patchValue({
      dlImagePath: this.uploadedFileNameDl
    })
  }

  fileChooserAndroidDl(sourceType: string) {
    console.log(sourceType)
    disableFileChhoserfunction(sourceType)
  }

  removeImgDl() {
    this.savedDlFile = null;
    this.uploadDlDiv = true;
    this.uploadImgDivDl = false;
    this.uploadedFileNameDl = null;
    this.uploadedSignURLDl = null;
    this.uploadedFileDl = null;
    this.createSetupForm.get('dlImagePath').reset();
    this.createSetupForm.get('dlImage').reset();
  }

  onCreateSetup() {
    this.button = "SUBMIT";
    this.createSetupForm = this.formBuilder.group({
      refNo: [],
      firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      mobileNo: ['', [Validators.required, Validators.pattern("[6789][0-9]{9}")]],
      email: [this.riderEmail, [Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      dob: ['', Validators.required],
      education: ['', Validators.required],
      vehicleName: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$')]],
      vehicleType: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      vehicleNo: ['', [Validators.required, Validators.pattern('^[A-Za-z]{2}[\\ -]{0,1}[0-9]{2}[\\ -]{0,1}[A-Za-z]{1,2}[\\ -]{0,1}[0-9]{4}$')]],
      riderDlNo: ['', [Validators.required, Validators.pattern('^(([A-Za-z]{2}[0-9]{2})( )|(([A-Za-z]{2}[0-9]{2})()))((19|20)[0-9][0-9])[0-9]{7}$')]],
      aadhaarNo: ['', [Validators.required, Validators.pattern('^[0-9]{4}[ -]?[0-9]{4}[ -]?[0-9]{4}$')]],
      upiId: ['', Validators.required],
      accountNo: ['', Validators.required],
      ifscCode: ['', Validators.required],

      check: [],
      isVerified: [],
      activeStatus: [],
      reason: [],
      riderSelfie: [],
      riderSelfiePath: ['', Validators.required],
      aadhaarImage: [],
      aadhaarImagePath: ['', Validators.required],
      aadhaarBackImage: [],
      aadhaarBackImagePath: ['', Validators.required],
      dlImage: [],
      dlImagePath: ['', Validators.required],
    })
  }

  createRider() {
    console.log(this.createSetupForm);
    if (this.isAgreedTerms) {
      if (this.createSetupForm.get('firstName').value) {
        this.createSetupForm.get('firstName').setValue(this.createSetupForm.get('firstName').value.trim());
      }
      if (this.createSetupForm.get('lastName').value) {
        this.createSetupForm.get('lastName').setValue(this.createSetupForm.get('lastName').value.trim());
      }
      if (this.createSetupForm.get('mobileNo').value) {
        // this.createSetupForm.get('mobileNo').setValue(this.createSetupForm.get('mobileNo').value.trim());
      }
      if (this.createSetupForm.get('email').value) {
        // this.createSetupForm.get('email').setValue(this.createSetupForm.get('email').value.trim());
      }
      if (this.createSetupForm.get('dob').value) {
        // this.createSetupForm.get('dob').setValue(this.createSetupForm.get('dob').value.trim());
      }
      if (this.createSetupForm.get('education').value) {
        this.createSetupForm.get('education').setValue(this.createSetupForm.get('education').value.trim());
      }
      if (this.createSetupForm.get('vehicleName').value) {
        this.createSetupForm.get('vehicleName').setValue(this.createSetupForm.get('vehicleName').value.trim());
      }
      if (this.createSetupForm.get('vehicleType').value) {
        this.createSetupForm.get('vehicleType').setValue(this.createSetupForm.get('vehicleType').value.trim());
      }
      if (this.createSetupForm.get('vehicleNo').value) {
        this.createSetupForm.get('vehicleNo').setValue(this.createSetupForm.get('vehicleNo').value.trim());
      }
      if (this.createSetupForm.get('riderDlNo').value) {
        this.createSetupForm.get('riderDlNo').setValue(this.createSetupForm.get('riderDlNo').value.trim());
      }
      if (this.createSetupForm.get('upiId').value) {
        this.createSetupForm.get('upiId').setValue(this.createSetupForm.get('upiId').value.trim());
      }
      if (this.createSetupForm.get('accountNo').value) {
        this.createSetupForm.get('accountNo').setValue(this.createSetupForm.get('accountNo').value.trim());
      }
      if (this.createSetupForm.get('ifscCode').value) {
        this.createSetupForm.get('ifscCode').setValue(this.createSetupForm.get('ifscCode').value.trim());
      }
      if (!this.createSetupForm.get('refNo').value) {

        this.createSetupForm.get('isVerified').setValue(false);
      }
      this.createSetupForm.get('activeStatus').setValue(false);
      if (this.createSetupForm.invalid) {
        this.toastService.showErrorToast(this.constant.invalidFormToast);
      }
      else {
        let headingMessage = this.constant.SaveData;

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          height: '23%',
          width: '346px',
          data: { heading: headingMessage }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            if (this.createSetupForm.get('email').value == "") {
              this.createSetupForm.get('email').setValue(null);
            }

            // ----------------------Date Format----------------------
            if (this.createSetupForm.get('dob').value != null) {
              let momentDate = new Date(this.createSetupForm.get('dob').value);
              let formattedDate = moment(momentDate).format(this.constant.dateFormatForDBServer);
              this.createSetupForm.patchValue({
                dob: formattedDate
              })
            }

            //enable
            this.createSetupForm.get('firstName').enable();
            this.createSetupForm.get('lastName').enable();
            this.createSetupForm.get('email').enable();
            this.createSetupForm.get('dob').enable();
            this.createSetupForm.get('aadhaarNo').enable();
            this.createSetupForm.get('mobileNo').enable();
            this.createSetupForm.get('education').enable();
            this.createSetupForm.get('riderDlNo').enable();
            if (this.isAgreedTerms = false) {
              this.createSetupForm.get('checked').enable();
            }

            this.createRiderSubscription = this.createRiderService.insertRider(this.apiUrl.insertRider, this.createSetupForm, this.uploadedFileAadhaar, this.uploadedFileAadhaarBack, this.uploadedFileSelfie, this.uploadedFileDl).subscribe((data) => {
              if (!this.createSetupForm.get('refNo').value) {
                this.toastService.showSuccessToast("New Rider " + this.createSetupForm.get('firstName').value + this.constant.createdToast);
              } else {
                this.toastService.showSuccessToast("Rider " + this.createSetupForm.get('firstName').value + this.constant.updateToast);
              }
              this.localStorage.set("rider_details", JSON.stringify(data));
              this.localStorage.set('locId', JSON.stringify(data.fromLocationCode));
              this.localStorage.set("active_rider_status", JSON.stringify(false));
              this.localStorage.set("google_item", JSON.stringify(data.firstName + " " + data.lastName));
              this.localStorage.set('google_email', JSON.stringify(data.email))
              this.createSetupForm.reset();
              this.uploadImgDivAadhaar = false;
              this.uploadImgDivSelfie = false;
              this.uploadImgDivAadhaarBack = false;
              this.uploadImgDivDl = false;
              this.uploadedFileNameAadhaar = '';
              // if(this.localStorage.get("OS")=="Android")
              //   logOutApp();
              // else
              //   this.route.navigateByUrl("login")     
              this.route.navigateByUrl("dashboard")
              window.location.reload();
            },
              (error: HttpErrorResponse) => {
              });
          }
        })
      }
    } else {
      this.isAnimate = true;
      this.toastService.showErrorToast("Please agreed to the terms and conditions");
      setTimeout(() => {
        this.isAnimate = false;
      }, 500);
    }
  }

  clearBirthDate() {
    this.createSetupForm.get('dob').setValue(null);
  }

  getRiderByEmail() {
    this.uploadAadharDiv = true;
    this.uploadRiderSelfieDiv = true;
    this.uploadAadharBackDiv = true;
    this.uploadDlDiv = true;

    this.getRiderByEmailSubscription = this.createRiderService.getRiderByEmail(this.riderEmail).subscribe(data => {
      if (data) {
        // this.freeze = true;
        this.displayBackBtn = false;
        this.isRiderAgree = true;
        this.isAgreedTerms = true;
        this.button = "UPDATE";
        this.createSetupForm.patchValue({
          refNo: data.refNo,
          firstName: data.firstName,
          lastName: data.lastName,
          mobileNo: data.mobileNo,
          email: data.email,
          dob: data.dob,
          education: data.education,
          vehicleName: data.vehicleName,
          vehicleType: data.vehicleType,
          vehicleNo: data.vehicleNo,
          riderDlNo: data.riderDlNo,
          aadhaarNo: data.aadhaarNo,
          isVerified: data.isVerified,
          reason: data.reason,
          aadhaarImagePath: data.aadhaarImagePath,
          riderSelfiePath: data.riderSelfiePath,
          aadhaarBackImagePath: data.aadhaarBackImagePath,
          dlImagePath: data.dlImagePath,
          upiId: data.upiId,
          accountNo: data.accountNo,
          ifscCode: data.ifscCode,
        })
        if (data.isVerified == true) {
          this.freeze = true;
          this.createSetupForm.get('firstName').disable();
          this.createSetupForm.get('lastName').disable();
          this.createSetupForm.get('email').disable();
          this.createSetupForm.get('dob').disable();
          this.createSetupForm.get('aadhaarNo').disable();
          this.createSetupForm.get('mobileNo').disable();
          this.createSetupForm.get('education').disable();
          this.createSetupForm.get('check').disable();
          this.createSetupForm.get('riderDlNo').disable();

        }
        this.localStorage.set("rider_details", JSON.stringify(data));
        this.getImage("riderdetails/" + data.aadhaarImagePath, true);
        this.getRiderImage("riderdetails/" + data.riderSelfiePath, true)
        this.getAadhaarBackImage("riderdetails/" + data.aadhaarBackImagePath, true);
        this.getDlImage("riderdetails/" + data.dlImagePath, true);
      } else {
        this.displayBackBtn = true;
      }
    },

      (error: HttpErrorResponse) => {
        // this.insertErrorLog("getRiderByEmail", error);
      });
  }

  savedAddharFile: any;
  savedAddharBackFile: any;
  savedRiderSelfieForEdit: any;
  savedDlFile: any;
  uploadAadharDiv: boolean = false;
  uploadAadharBackDiv: boolean = false;
  uploadRiderSelfieDiv: boolean = false;
  uploadDlDiv: boolean = false;

  getImage(imageName: string, isAadhar: boolean) {
    this.imageSubscription = this.createRiderService.getImage(this.apiUrl.getFileServerOldUrl, imageName).subscribe((data) => {
      if (data.toString().includes("ArrayBuffer") == true) {
        let file = new Blob([data], { type: 'image/jpeg' });
        let fl1 = URL.createObjectURL(file);
        let fl2: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(fl1);
        if (!isAadhar) {
          // this.uplodedFile = data;
          // this.savedFileForEdit = fl2;
        } else {
          this.uploadImgDivAadhaar = true;
          this.uplodedFileForAddhar = data;
          this.savedAddharFile = fl2;
        }
      }
    },
      (error: HttpErrorResponse) => {
        // this.insertErrorLog("getImage", error);
      });
  }

  getRiderImage(imageName: string, isRiderSelfie: boolean) {
    this.imageSubscription = this.createRiderService.getImage(this.apiUrl.getFileServerOldUrl, imageName).subscribe((data) => {
      if (data.toString().includes("ArrayBuffer") == true) {
        let file = new Blob([data], { type: 'image/jpeg' });
        let fl1 = URL.createObjectURL(file);
        let fl2: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(fl1);
        if (!isRiderSelfie) {
          // this.uplodedFile = data;
          // this.savedFileForEdit = fl2;
        } else {
          this.uploadImgDivSelfie = true;
          this.uplodedFileForRider = data;
          this.savedRiderSelfieForEdit = fl2;
        }
      }
    },
      (error: HttpErrorResponse) => {
        // this.insertErrorLog("getImage", error);
      });
  }

  getAadhaarBackImage(imageName: string, isAadhaarBack: boolean) {
    this.imageSubscription = this.createRiderService.getImage(this.apiUrl.getFileServerOldUrl, imageName).subscribe((data) => {
      if (data.toString().includes("ArrayBuffer") == true) {
        let file = new Blob([data], { type: 'image/jpeg' });
        let fl1 = URL.createObjectURL(file);
        let fl2: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(fl1);
        if (!isAadhaarBack) {
        } else {
          this.uploadImgDivAadhaarBack = true;
          this.uploadedFileForAadhaarBack = data;
          this.savedAddharBackFile = fl2;
        }
      }
    },
      (error: HttpErrorResponse) => {
      });

  }

  getDlImage(imageName: string, isDl: boolean) {
    this.imageSubscription = this.createRiderService.getImage(this.apiUrl.getFileServerOldUrl, imageName).subscribe((data) => {
      if (data.toString().includes("ArrayBuffer") == true) {
        let file = new Blob([data], { type: 'image/jpeg' });
        let fl1 = URL.createObjectURL(file);
        let fl2: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(fl1);
        if (!isDl) {
        } else {
          this.uploadImgDivDl = true;
          this.uploadedFileForDl = data;
          this.savedDlFile = fl2;
        }
      }
    },
      (error: HttpErrorResponse) => {
      });
  }

  imageClick(image: any) {
    const dialogRef = this.dialog.open(ImagePreviewDialogComponent, {
      width: '500px',
      height: '300px',
      autoFocus: false,
      data: { image }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  goBack() {
    this.route.navigate(['/login']);
  }
}
